import React, { useCallback } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import OfferPagePromoLinks from './OfferPagePromoLinks/OfferPagePromoLinks.container';
import OfferPagePromoBanners from './OfferPagePromoBanners/OfferPagePromoBanners.container';
import OfferPagePromoContainers from './OfferPagePromoContainers/OfferPagePromoContainers.container';
import OfferPagePromoLandings from './OfferPagePromoLandings/OfferPagePromoLandings.container';

const startTab = 'links';

const OfferPagePromo = ({ location, t, ...props }) => {
    const getClassActiveBtn = useCallback((type) => {
        let material = location && location.query && location.query.type || startTab;

        return classNames({
            'btn': true,
            'btn-outline': true,
            'btn-success': true,
            'active': material === type
        });
    }, [location]);

    const getClassActivePanel = useCallback((event) => {
        let target = event.target;
        let button = null === target.querySelector('.tab-icon') ? event.target : target.querySelector('.tab-icon');
        let content = target.closest('.offer-item__promo-block').querySelector('.ibox');

        button.classList.toggle('fa-chevron-down');
        button.classList.toggle('fa-chevron-up');
        content.classList.toggle('hidden');
    }, []);

    const staticNames = (t && t.offersPage && t.offersPage.offer) || {};

    return (
        <div className="offer-item__promo">
            <div className="offer-item__promo-block links-block">
                <div className="links-block__tab tab chevron-icon" onClick={getClassActivePanel}>
                    <span>{staticNames.links}</span>
                    <span className="tab-icon fa fa-chevron-down"></span>
                </div>
                <OfferPagePromoLinks
                    params={props.params}
                    showConstructor={props.showConstructor}
                    showConstructorPromoCode={props.showConstructorPromoCode}
                    showConstructorPromoCodeList={props.showConstructorPromoCodeList}
                />
            </div>
            <div className="offer-item__promo-block banners-block">
                <div className="banners-block__tab tab chevron-icon" onClick={getClassActivePanel}>
                    <span>{staticNames.banners}</span>
                    <span className="tab-icon fa fa-chevron-up"></span>
                </div>
                <OfferPagePromoBanners
                    params={props.params}
                    showConstructor={props.showConstructor}
                />
            </div>
            <div className="offer-item__promo-block landings-block">
                <div className="landings-block__tab tab chevron-icon" onClick={getClassActivePanel}>
                    <span>{staticNames.landings}</span>
                    <span className="tab-icon fa fa-chevron-up" data-type="icon"></span>
                </div>
                <OfferPagePromoLandings
                    params={props.params}
                    showConstructor={props.showConstructor}
                />
            </div>
        </div>
    );
};

OfferPagePromo.propTypes = {
    location: PropTypes.object,
    t: PropTypes.object
};

export default withTranslation(OfferPagePromo);